import levelService from '~/services/level.service';
import { customerActions, hintActions, uiActions, loadingActions, gameSelectors, levelSelectors } from '~/store';
import { TURN_UPDATE_SAVE_CHECKPOINT_AFTER_FETCH} from '~/store/turn/actionTypes';
import { UI_UPDATE_HAS_PENDING_CUSTOMER_TYPE_HINTS } from '~/store/ui/actionTypes';
import { LEVELS_WITH_NEW_CUSTOMER_TYPES, TEMP_END_LEVEL } from '~/lib/constants';
// ---- internal imports ----

import { LEVEL_COMPLETED, LEVEL_GO_TO_NEW_LEVEL } from '../actionTypes';
// ---- parent imports ----

import setupLevel from './setupLevel';
import finalLevelCompleted from './finalLevelCompleted';
// ---- local imports ----


function goToNewLevel(newLevel) {
	return async (dispatch, getState) => {
		// TEMPORARY (5076): never advance past the temp end level. Covers the
		// loadLevel recovery path (passed a level but the advance request had
		// failed) and acts as a general backstop for the level cap.
		if (newLevel > TEMP_END_LEVEL) {
			dispatch(finalLevelCompleted());
			return;
		}

		const previousLevel = newLevel - 1;
		const shouldSaveCompletionAfterNewTurn = levelSelectors.shouldSaveCompletionAfterNewTurn(getState(), previousLevel);
		dispatch({ type: LEVEL_GO_TO_NEW_LEVEL, isLoadingNewLevel: true });
	
		dispatch({ type: TURN_UPDATE_SAVE_CHECKPOINT_AFTER_FETCH, save: shouldSaveCompletionAfterNewTurn});
		dispatch(loadingActions.start(LEVEL_GO_TO_NEW_LEVEL));

		const newMissions = setupLevel(getState(), newLevel);
		const levelData = levelSelectors.getLevelData(getState(), newLevel - 1);

		const result = await levelService.saveLevelData(
			gameSelectors.getGameId(getState()),
			newLevel, 
			newMissions,
			{}
		);

		if (!result.isSuccess) {
			dispatch(loadingActions.endAfterNetworkFaliures());
			return;
		}

		dispatch({
			type: LEVEL_COMPLETED,
			level: newLevel,
			missions: newMissions,
			story: levelData.story,
			featuresToUnlock: levelData.featuresToUnlock,
			isFirstAttemptInLevel: true,
			shouldSaveCompletionAfterNewTurn	// added for epic
		});

		dispatch({
			type: UI_UPDATE_HAS_PENDING_CUSTOMER_TYPE_HINTS,
			hasPendingCustomerTypeHint: LEVELS_WITH_NEW_CUSTOMER_TYPES.includes(newLevel),
		});

		dispatch(loadingActions.end(LEVEL_GO_TO_NEW_LEVEL));

		dispatch(customerActions.skipCurrentCustomers());
		dispatch(hintActions.hideCurrent());
		dispatch(uiActions.showNewLevelModal());

		// this is only to handle level hopping
		dispatch({ type: LEVEL_GO_TO_NEW_LEVEL, isLoadingNewLevel: false });
	};
}


export default goToNewLevel;
